exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{height:100%;width:100%;margin:0;padding:0;overflow:hidden;font-family:Roboto,sans-serif}body .loginform{width:400px;background-color:#fff;margin:15% auto;padding:0 30px;box-shadow:0 0 17px -5px #000}body .loginform header{background:var(--logo-path) no-repeat 50%;width:100%;min-height:150px}body .loginform main{margin-bottom:20px}body .loginform main a{width:118%;margin-left:-30px;padding:15px 0;font-size:16px}body .loginform input{border-radius:0;max-width:400px}body .loginform input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #fff inset}body .loginform i{margin-right:5px}body .loginform p{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./client/app/components/login/login.less
// module id = 1022
// module chunks = 0